// data.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DataService {

  constructor(private http: HttpClient) { }

  getIpAddress() {
    return this.http.get("https://api.ipify.org/?format=json");
  }

  private dataArray: any[] = [];
  eventId: any;
  userId: any;
  userName: any;
  totalImages: any;
  profileUrl: any;
  prevUserImage: any = null;
  isAnonymous: boolean = false;
  private needRefresh = new BehaviorSubject<any>(null);
  private myVariableSource = new BehaviorSubject<any>(null);
  private updatedGuestbookEntries = new BehaviorSubject<any>(null);
  needRefresh$ = this.needRefresh.asObservable();
  updatedGuestbookEntries$ = this.updatedGuestbookEntries.asObservable();
  eventHex: any;
  updateResult: any;
  isPrivateVisible: boolean = false;

  // showTopBar getter/setter that syncs with localStorage for persistence across page reloads
  private _showTopBar: boolean = true;

  get showTopBar(): boolean {
    // Read from localStorage on every access to catch changes from other components or after reload
    const stored = localStorage.getItem('showTopBar');
    if (stored !== null) {
      this._showTopBar = stored === 'true';
    }
    return this._showTopBar;
  }

  set showTopBar(value: boolean) {
    this._showTopBar = value;
    // Persist to localStorage so it survives page reloads
    localStorage.setItem('showTopBar', value.toString());
  }

  setVariable(value: any) {
    this.needRefresh.next(value);
  }

  getArray(): any[] {
    return this.dataArray;
  }

  updateArray(newArray: any[]): void {
    this.dataArray = newArray;
  }

  showTopMenuBar(value: any) {
    return this.showTopBar;
  }

  setUpdatedGuestbookEntries(entries: any[]) {
    this.updatedGuestbookEntries.next(entries);
  }


}